import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";
export default class AllCalendarService extends ApiService {
  DOMAIN = DOMAIN.CALENDAR;
  constructor() {
    super("calendars/bulk");
  }
}
